/// <reference types="react" />

import * as React from 'react';
import { Link } from "VSSUI/Link";
import * as Resources from "WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking";

export interface IAddParentLinkProps {
    onClickAddParent: () => void;
}

export const AddParentLink: React.FunctionComponent<IAddParentLinkProps> = props => {
    return (
        <div className="zero-data-action margin-bottom-8">
            <div>
                <Link onClick={props.onClickAddParent}>{Resources.AddParentText1}</Link>
                <span>{Resources.AddParentText2}</span>
            </div>
        </div>
    )
}